/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form, Alert } from "react-bootstrap";
import { Information, DollarSquare, CardAdd, Judge} from "iconsax-react";
import { Link, useNavigate } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { sports, tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";

export const CoursesNew = () => {

    const navigate = useNavigate();
    const { profile: profileData } = useProfile({
        autoFetch: true,
        includeTitles: true
    });

    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED';

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);
    const [confirmText, setConfirmText] = useState('');

    const [modalCentered, setModalCentered] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);


    const [enabledSports, setEnabledSports] = useState([])

    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });



	useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }

    }, [profileData]);

    useEffect(() => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, []);

    const [formData, setFormData] = useState({
        name: '', 
        sportType: '',
        type: 'OPEN',
        maxMembers: 0,
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        newCoursePicture: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };



    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const formRefs = useRef({});

    const handleDraftSaveClick = () => {
        if (!formData.name || formData.name.trim() === '') {
            setModalTitle("Errore di validazione");
            setModalText("Devi inserire il nome per salvare la bozza");
            setModalShowed(true);
            return;
        }
        const form = formRefs.current[tabIndex];
        if (form) {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId;
                formData.status = 'DRAFT';
                saveData();
            }
        }
    };

    const handleSaveClick = (numOfTab, status) => {
        const form = formRefs.current[tabIndex];

        if(numOfTab<4) {
            if (form) {
                let isValid = true;
                for (const element of form.elements) {
                    if (element.name === "standard_price" || element.name === "member_price" || element.name === "federated_price") {
                        if (element.disabled) {
                            element.setCustomValidity("");
                        } else {
                            const value = parseFloat(element.value);
                            if (value <= 0 || isNaN(value)) {
                                element.setCustomValidity("Il prezzo deve essere maggiore di 0");
                                isValid = false;
                            } else {
                                element.setCustomValidity("");
                            }
                        }
                    }

                    if (element.name === "fitcoin_cashback") {
                        const value = parseFloat(element.value);
                        if (value < 0 || isNaN(value)) {
                            element.setCustomValidity("Il valore deve essere maggiore o uguale a 0");
                            isValid = false;
                        } else {
                            element.setCustomValidity("");
                        }
                    }
                }

                // Now check form validity after custom validation
                if (!form.checkValidity() || !isValid) {
                    form.reportValidity();
                    return;
                }

                if(numOfTab === 1) {
                    if(form.checkValidity() && isValid && !formData.newCoursePicture) {
                        setModalTitle("Errore di validazione");
                        setModalText("Devi selezionare una immagine del prodotto per continuare");
                        setModalShowed(true);
                        return;
                    }
                }

                if(numOfTab === 3) {
                    // Validazione campi payable nel tab Prezzi
                    if (!formData.payable_in_club && !formData.payable_stripe && !formData.payable_bank) {
                        setModalTitle("Errore di validazione");
                        setModalText("Almeno uno dei metodi di pagamento deve essere selezionato (In Struttura, Stripe o Bonifico)");
                        setModalShowed(true);
                        return;
                    }
                }

                if (form.checkValidity() && isValid) {
                    setTabIndex(numOfTab);
                    setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }, 100);
                }
            }
        } else {

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId
                formData.status = status
                if(status === 'DRAFT') {
                    saveData();
                } else if(status === 'PURCHASABLE') {
                    saveConfirm();
                }
            }
        }
    };

    const saveConfirm = () => {
		setOnContinue(() => () => saveData());
		setConfirmShowed(true);
		setConfirmText("Sei sicuro di volere continuare? La tipologia corso sarà creata e non sarà più possibile modificarne i dati.");
    };

    // L'immagine viaggia come { content, name }: la si invia solo se ne e' stata
    // scelta una nuova, altrimenti si omette il campo (un content null oppure un
    // oggetto gia' incapsulato faceva fallire lo schema con "must be string").
    const preparePicturePayload = (payload, field) => {
        const current = payload[field];
        const content = typeof current === 'string' ? current : current?.content;
        if (content) {
            payload[field] = {
                content: content,
                name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
            };
        } else {
            delete payload[field];
        }
    };

    const saveData = async () => {
        try {
            const payload = { ...formData };

            if(!showingSociOptions) {
                payload.member_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) {
                payload.federated_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) { payload.federated_price = payload.standard_price; }

            preparePicturePayload(payload, 'newCoursePicture');

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                const result = await apiClient.createBookingCourse(token, payload);
                setLoadingShowed(false);

                if(result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/courses');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    }

    const saveAndActivate = () => {
        setOnContinue(() => () => saveDataAndActivate());
        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? Il corso sarà attivato automaticamente.");
    };

    const saveDataAndActivate = async () => {
        try {
            const payload = { ...formData };

            if(!showingSociOptions) {
                payload.member_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) {
                payload.federated_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) { payload.federated_price = payload.standard_price; }

            preparePicturePayload(payload, 'newCoursePicture');

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                payload.clubId = tokenDetails.localId;
                payload.status = 'DRAFT';
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                // First, create the course as draft
                const result = await apiClient.createBookingCourse(token, payload);
                
                if(result && result.error) {
                    setLoadingShowed(false);
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                    return;
                }

                // Then, activate the course
                if(result && result.id) {
                    const activateResult = await apiClient.changeCourseStatus(token, result.data.id, 'PURCHASABLE');
                    setLoadingShowed(false);
                    
                    if(activateResult && activateResult.error) {
                        setModalTitle("Errore durante l'attivazione");
                        setModalText(activateResult.error);
                        setModalShowed(true);
                    } else {
                        navigate('/struttura/booking/courses');
                    }
                } else {
                    setLoadingShowed(false);
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Errore nella creazione del corso");
                    setModalShowed(true);
                }
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in saveDataAndActivate: '+error);
            setModalTitle("Errore durante l'operazione");
            setModalText("Errore generico durante il salvataggio e attivazione");
            setModalShowed(true);
        }   
    }

    const goBack = (numOfTab) => {
        if(numOfTab>-1) {
            setTabIndex(numOfTab);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        } else {
            navigate('/struttura/booking/courses');
        }
	};

    // Campi si'/no: un interruttore su una riga, non una tendina
    const renderSwitchField = (fieldName, label) => (
        <div className="sid-switch-row">
            <Form.Check
                type="switch"
                id={`switch-${fieldName}`}
                label={label}
                checked={!!formData[fieldName]}
                onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
            />
        </div>
    );

    const siNo = (value) => (value ? 'Sì' : 'No');
    const hasValue = (value) => value || value === 0;

	const tabData = [
		{
			id: 'informazioni_generali',
			name: "Informazioni generali",
			icon: <i className="fas fa-info-circle me-2"></i>,
			content: (
                <>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[0] = el} noValidate>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label className="mb-2">Nome corso *</Form.Label>
                                        <Form.Control required className="mt-2" type="text" name="name" value={formData.name} onChange={handleChange} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="mb-2">Sport *</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            styles={sidSelectStyles}
                                            name="sportType"
                                            value={enabledSports.find(option => option.value === formData.sportType)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "sportType")}
                                            options={enabledSports}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="mb-2">Partecipanti massimi *</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="number"
                                            min="1"
                                            name="maxMembers"
                                            value={formData.maxMembers}
                                            onChange={handleChange}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label className="mb-2">Descrizione *</Form.Label>
                                        <Form.Control required className="mt-2" rows={10} as="textarea" name="description" value={formData.description || ''} onChange={handleChange} />
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Foto *</Form.Label>
                                        <div className="sid-photo-field">
                                            <div className="sid-photo-field__preview">
                                                {formData.newCoursePicture ?
                                                    <img src={`data:image/jpeg;base64,${formData.newCoursePicture}`} alt="" />
                                                :
                                                    <span>Nessuna foto</span>
                                                }
                                            </div>
                                            <Button size="sm" variant="outline-dark" onClick={() => setModalCentered(true)}>
                                                {formData.newCoursePicture ? 'Sostituisci foto' : 'Carica foto'}
                                            </Button>
                                            {formData.newCoursePicture && (
                                                <Button size="sm" variant="outline-danger" onClick={handleRemoveImage}>
                                                    Rimuovi
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4">
                        <button type="button" className="btn btn-dark light" onClick={() => goBack(-1)}>Annulla</button>
                        <Link onClick={() => handleDraftSaveClick()} to="#" className="btn btn-secondary">Salva come bozza</Link>
                        <Link onClick={() => handleSaveClick(1, 'DRAFT')} to="#" className="btn btn-primary ">Avanti</Link>
                    </div>
                </>
			),
		},
		{
			id: 'prezzi',
			name: "Prezzi",
			icon: <DollarSquare size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                <Row className="g-4">
                                    <Col md={3}>
                                        <Form.Label className="mb-2">Prezzo standard *</Form.Label>
                                        <Form.Control required disabled={sdiEnabledNoVat || billingNotConfirmed} className="mt-2" style={(sdiEnabledNoVat || billingNotConfirmed) ? {color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal"} : undefined} type="text" name="standard_price" value={formData.standard_price} onChange={handleChange} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="mb-2">IVA</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            styles={sidSelectStyles}
                                            isDisabled={sdiEnabledNoVat || billingNotConfirmed}
                                            name="vat_rate"
                                            value={findVatOption(formData)}
                                            onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                                            options={VAT_OPTIONS}
                                        />
                                    </Col>
                                    {showingTesseratiOptions &&
                                    <Col md={3}>
                                        <Form.Label className="mb-2">Prezzo tesserati / soci *</Form.Label>
                                        <Form.Control required className="mt-2" type="text" name="federated_price" value={formData.federated_price} onChange={handleChange} />
                                    </Col>
                                    }
                                    <Col md={3}>
                                        <Form.Label className="mb-2">Cashback Fitcoin *</Form.Label>
                                        <Form.Control required className="mt-2" type="text" name="fitcoin_cashback" value={formData.fitcoin_cashback} onChange={handleChange} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4">
                        <Link onClick={() => goBack(0)} to="#" className="btn btn-dark light">Indietro</Link>
                        <Link onClick={() => handleDraftSaveClick()} to="#" className="btn btn-secondary">Salva come bozza</Link>
                        <Link onClick={() => handleSaveClick(2, 'DRAFT')} to="#" className="btn btn-primary ">Avanti</Link>
                    </div>
                </>
			),
		},
		{
			id: 'condizioni_aggiuntive',
			name: "Condizioni aggiuntive",
			icon: <CardAdd size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[2] = el} noValidate>
                                <div className="sid-switch-inline">
                                    {renderSwitchField("payable_in_club", "Acquisto pagabile in struttura *")}
                                    {paymentMethods.stripe_enabled && renderSwitchField("payable_stripe", "Acquisto pagabile su Stripe *")}
                                    {paymentMethods.bank_transfer_enabled && renderSwitchField("payable_bank", "Acquisto pagabile con bonifico *")}
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4">
                        <Link onClick={() => goBack(1)} to="#" className="btn btn-dark light">Indietro</Link>
                        <Link onClick={() => handleDraftSaveClick()} to="#" className="btn btn-secondary">Salva come bozza</Link>
                        <Link onClick={() => handleSaveClick(3, 'DRAFT')} to="#" className="btn btn-primary ">Avanti</Link>
                    </div>
                </>
			),
		},
		{
			id: 'riepilogo',
			name: "Riepilogo e conferma",
			icon: <Judge size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[3] = el} noValidate>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label>Nome corso</Form.Label>
                                        <div className="sid-readonly-value">{formData.name || '-'}</div>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>Sport</Form.Label>
                                        <div className="sid-readonly-value">{enabledSports.find(option => option.value === formData.sportType)?.label || '-'}</div>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>Partecipanti massimi</Form.Label>
                                        <div className="sid-readonly-value">{hasValue(formData.maxMembers) ? formData.maxMembers : '-'}</div>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Descrizione</Form.Label>
                                        <div className="sid-readonly-value" style={{ whiteSpace: 'pre-line' }}>{formData.description || '-'}</div>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Foto</Form.Label>
                                        <div className="sid-photo-field">
                                            <div className="sid-photo-field__preview">
                                                {formData.newCoursePicture ?
                                                    <img src={`data:image/jpeg;base64,${formData.newCoursePicture}`} alt="" />
                                                :
                                                    <span>Nessuna foto</span>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Prezzi</h5>
                                <Row className="g-4">
                                    <Col md={3}>
                                        <Form.Label>Prezzo standard</Form.Label>
                                        <div className="sid-readonly-value">{hasValue(formData.standard_price) ? formData.standard_price : '-'}</div>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>IVA</Form.Label>
                                        <div className="sid-readonly-value">{findVatOption(formData)?.label || '-'}</div>
                                    </Col>
                                    {showingTesseratiOptions &&
                                    <Col md={3}>
                                        <Form.Label>Prezzo tesserati / soci</Form.Label>
                                        <div className="sid-readonly-value">{hasValue(formData.federated_price) ? formData.federated_price : '-'}</div>
                                    </Col>
                                    }
                                    <Col md={3}>
                                        <Form.Label>Cashback Fitcoin</Form.Label>
                                        <div className="sid-readonly-value">{hasValue(formData.fitcoin_cashback) ? formData.fitcoin_cashback : '-'}</div>
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Forme di pagamento</h5>
                                <Row className="g-4">
                                    <Col md={4}>
                                        <Form.Label>Acquisto pagabile in struttura</Form.Label>
                                        <div className="sid-readonly-value">{siNo(formData.payable_in_club)}</div>
                                    </Col>
                                    {paymentMethods.stripe_enabled && (
                                    <Col md={4}>
                                        <Form.Label>Acquisto pagabile su Stripe</Form.Label>
                                        <div className="sid-readonly-value">{siNo(formData.payable_stripe)}</div>
                                    </Col>
                                    )}
                                    {paymentMethods.bank_transfer_enabled && (
                                    <Col md={4}>
                                        <Form.Label>Acquisto pagabile con bonifico</Form.Label>
                                        <div className="sid-readonly-value">{siNo(formData.payable_bank)}</div>
                                    </Col>
                                    )}
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4">
                        <Link onClick={() => goBack(2)} to="#" className="btn btn-dark light">Indietro</Link>
                        <Link onClick={() => handleSaveClick(4, 'DRAFT')} to="#" className="btn btn-secondary">Salva come bozza</Link>
                        {!billingNotConfirmed && <Link onClick={() => saveAndActivate()} to="#" className="btn btn-primary">Salva e attiva</Link>}
                    </div>
                </>
			),
		}
	];

    function handleRemoveImage() {
        setFormData({
            ...formData,
            newCoursePicture: null
        });
    }

	return (
		<>
			<ProductImageUploader
                show={modalCentered}
                onClose={() => setModalCentered(false)}
                onSave={(base64String) => {
                    setModalCentered(false);
                    setFormData(prev => ({ ...prev, newCoursePicture: base64String }));
                }}
                titolo="Immagine del corso"
            />
            
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Sei sicuro?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Chiudi
                    </Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Continua
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			{billingNotConfirmed && (
				<Alert variant="warning" className="d-flex align-items-start gap-2 text-dark" style={{ marginBottom: '1rem' }}>
					<Information size="20" className="mt-1 flex-shrink-0" />
					<div>
						<strong>Metodo di fatturazione non configurato.</strong> Per pubblicare prodotti e renderli acquistabili nell'App SportId Player è necessario configurare e confermare il metodo di fatturazione nella sezione <strong>La mia struttura → Documenti fiscali</strong>. Puoi continuare a creare prodotti e salvarli come bozza.
					</div>
				</Alert>
			)}

			<div className="custom-tab-1">
                <Tab.Container activeKey={tabData[tabIndex]?.id.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link onClick={(e) => e.preventDefault()} eventKey={data.id.toLowerCase()} style={{ cursor: 'default', pointerEvents: 'none' }}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-12">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
					</Row>
				</Tab.Container>
			</div>
		</>
	)
}
export default CoursesNew;